import React from "react"
import NewJobDetailPageBanner from "../components/new-job-detail/detail-page-banner"
import JobHighlight from "../components/new-job-detail/job-highlight"
import Header from "../components/new-home/header"
import SearchResultCard from "../components/search-result-card"

import logo01 from "../images/logo-01.png"
import logo02 from "../images/logo-02.png"
import logo03 from "../images/logo-03.png"
import logo04 from "../images/logo-04.png"

import "../components/new-job-detail/detail.scss"
import RequiredSkills from "../components/new-job-detail/skills"
import JobDetail from "../components/new-job-detail/job-detail"

import "../components/new-home/global.scss"
import "../components/new-home/spacers.scss"

export default function NewJobDetailPage() {
  const SearchResultData = [
    {
      id: 1,
      companyName: "Smart Tech",
      post: "Software Engineer",
      companyLogo: logo01,
      address: "Kathmandu, Nepal",
      minExperience: "2 Years",
      baseSalary: "60,000",
      lastUpdated: "8 hours ago",
      brief:
        "Lead client-facing activities related to relationship building and maintenance, client ...",
      jobType: "Remote",
    },
    {
      id: 2,
      companyName: "InfomatriX",
      post: "Data Analyst",
      companyLogo: logo02,
      address: "lalitpur, Nepal",
      minExperience: "2 Years",
      baseSalary: "60,000",
      lastUpdated: "18 hours ago",
      brief:
        "Gather business requirements and interact with clients to deliver the required business reports ...",
      jobType: "Remote",
    },
    {
      id: 3,
      companyName: "A12 Soft",
      post: "QA Engineer",
      companyLogo: logo03,
      address: "Kathmandu, Nepal",
      minExperience: "3 Years",
      baseSalary: "60,000",
      lastUpdated: "2 days ago",
      brief:
        "Ensure company-wide alignment to the Knowledge Management Software Validation Process ...",
      jobType: "Remote",
    },
    {
      id: 4,
      companyName: "Axis Corp",
      post: "React Developer",
      companyLogo: logo04,
      address: "Lalitpur, Nepal",
      minExperience: "2 Years",
      baseSalary: "60,000",
      lastUpdated: "2 hours ago",
      brief:
        "Lead client-facing activities related to relationship building and maintenance, client ...",
      jobType: "Remote",
    },
  ]
  return (
    <>
      <Header />
      <section className="wdn-new wdn-job-detail bg-light-blue">
        <div className="container">
          <div className="row">
            <div className="col-xl-9">
              <NewJobDetailPageBanner />

              <div className="row">
                <div className=" col-lg-4 col-12">
                  <aside className="wjd-key-highlight">
                    <JobHighlight />
                    <RequiredSkills />
                  </aside>
                </div>
                <div className=" col-lg-8 col-12">
                  <JobDetail />
                </div>
              </div>
            </div>
            <div className="col-xl-3 ">
              <aside className="wjd-aside">
                <h5>Similar Jobs</h5>
                <div className="row">
                  {SearchResultData.map(result => (
                    <div className="col-12 col-md-6 col-xl-12" key={result.id}>
                      <SearchResultCard
                        companyName={result.companyName}
                        post={result.post}
                        companyLogo={result.companyLogo}
                        address={result.address}
                        minExperience={result.minExperience}
                        baseSalary={result.baseSalary}
                        lastUpdated={result.lastUpdated}
                        brief={result.brief}
                        jobType={result.jobType}
                        isAside={true}
                      />
                    </div>
                  ))}
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
